import spartaSqueezeboxUtility from '@sparta.global.utilities/sparta-squeezebox-utility/dist/es6.js';
import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import { currencyRoundedInt, percentage, getCustomFormattedDate } from '@sparta.sales.helpers/module-utils-helper/dist/es6.js';
import { layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"column small-12 background-color main-padding\">\r\n      <p data-mapping=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"headlineDataMapping") : depth0), depth0))
    + "\" class=\"headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":4,"column":70},"end":{"line":4,"column":84}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n      <p class=\"subHeadline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"subHeadline") || (depth0 != null ? lookupProperty(depth0,"subHeadline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subHeadline","hash":{},"data":data,"loc":{"start":{"line":5,"column":29},"end":{"line":5,"column":46}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n    </div>\r\n    <div class=\"column small-12 background-color desc-text custom-text\">\r\n    <div class=\"homeIcon\"> <img src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"homeicon") || (depth0 != null ? lookupProperty(depth0,"homeicon") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"homeicon","hash":{},"data":data,"loc":{"start":{"line":8,"column":37},"end":{"line":8,"column":49}}}) : helper)))
    + "\" width=\"64\" alt=\"\" aria-hidden=\"true\"/> </div>\r\n    </div>\r\n    <div class=\"column small-12 background-color main-padding futureActions\">\r\n      <p data-mapping=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"headlineDataMapping") : depth0), depth0))
    + "\" class=\"line1 headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":11,"column":76},"end":{"line":11,"column":93}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n      <p data-mapping=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"headlineDataMapping") : depth0), depth0))
    + "\" class=\"line2 headline\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"descriptionOther") || (depth0 != null ? lookupProperty(depth0,"descriptionOther") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"descriptionOther","hash":{},"data":data,"loc":{"start":{"line":12,"column":76},"end":{"line":12,"column":96}}}) : helper)))
    + "</p>\r\n    </div>\r\n    <div class=\"column small-12 background-color main-padding custom-text\">\r\n      <p class=\"desc-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"descriptionconditional") || (depth0 != null ? lookupProperty(depth0,"descriptionconditional") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"descriptionconditional","hash":{},"data":data,"loc":{"start":{"line":15,"column":27},"end":{"line":15,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n      <div class=\"future-text-learn-more-buttons\">\r\n        <div class=\"calc-buttons\">\r\n          "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"startAnApplication") || (depth0 != null ? lookupProperty(depth0,"startAnApplication") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"startAnApplication","hash":{},"data":data,"loc":{"start":{"line":18,"column":10},"end":{"line":18,"column":34}}}) : helper))) != null ? stack1 : "")
    + "\r\n        </div>\r\n        <div class=\"learnMore-button\">\r\n          "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"learnMore") || (depth0 != null ? lookupProperty(depth0,"learnMore") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":21,"column":10},"end":{"line":21,"column":25}}}) : helper))) != null ? stack1 : "")
    + "\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"column small-12 background-color secondary-padding notop-margin\">\r\n      <div class=\"squeezebox-wrapper\" id=\"loanDetailsAccordion\" data-accordion-type=\"accordion\" data-one-at-a-time=\"false\">\r\n        <div class=\"squeezebox-panels\" data-one-at-a-time=\"false\">\r\n          <div class=\"squeezebox-panel spa-squeezebox-item\" id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"accordion") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "Panel\">\r\n            <a href=\"javascript:void(0)\" class=\"panel-header-holder spa-oline spa-squeezebox-heading transparent\" data-panel=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"accordion") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "Panel\" id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"accordion") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "Accordion\" role=\"application\">\r\n              <span class=\"spa-squeezebox-arrow spa-icon "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + "\"></span>\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? lookupProperty(stack1,"details") : stack1),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":14},"end":{"line":34,"column":23}}})) != null ? stack1 : "")
    + "              <span class=\"ada-hidden\"></span></a>\r\n            <div class=\"panel-content transparent\" style=\"background-color: #F5F5F6\" aria-labelledby=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"accordion") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "Accordion\">\r\n              <div id=\"content-loan-details\" class=\"content content-loan-details row spa-squeezebox-content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"list") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":16},"end":{"line":48,"column":25}}})) != null ? stack1 : "")
    + "                <div class=\"column medium-6 disclaimer-buffer\">\r\n                </div>\r\n                <div class=\"column medium-6 large-push-1 disclaimer-area\">\r\n                  <p class=\"disclaimer-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"disclaimer") || (depth0 != null ? lookupProperty(depth0,"disclaimer") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"disclaimer","hash":{},"data":data,"loc":{"start":{"line":52,"column":45},"end":{"line":52,"column":61}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n                  "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"disclosures") || (depth0 != null ? lookupProperty(depth0,"disclosures") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"disclosures","hash":{},"data":data,"loc":{"start":{"line":53,"column":18},"end":{"line":53,"column":35}}}) : helper))) != null ? stack1 : "")
    + "\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <ul class=\"column small-12 medium-6 large-5 large-push-1 row\"> "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"header") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"item") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":20},"end":{"line":46,"column":29}}})) != null ? stack1 : "")
    + "                  </ul>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      <li class=\"column small-12 medium-"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"columns") : depth0), depth0))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":24},"end":{"line":44,"column":33}}})) != null ? stack1 : "")
    + "                      </li>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                          "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"infoLayerLoanAmountContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":4},"end":{"line":67,"column":21}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"infoLayerInterestRateContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":68,"column":4},"end":{"line":70,"column":21}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"infoLayerPrincipalAndInterestPaymentContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":71,"column":4},"end":{"line":73,"column":21}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"infoLayerEscrowPaymentContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":74,"column":4},"end":{"line":76,"column":21}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"infoLayerAPRContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":77,"column":4},"end":{"line":80,"column":21}}})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"infoLayerLoanAmountContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"infoLayerInterestRateContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"infoLayerPrincipalAndInterestPaymentContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"infoLayerEscrowPaymentContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"infoLayerAPRContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"infoLayerAPRContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text2") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row wrapper\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":62,"column":11}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1),{"name":"with","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":2},"end":{"line":81,"column":11}}})) != null ? stack1 : "")
    + "\r\n</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/detailed-information-about-loan-module",
  "version": "3.0.1",
  "id": "detailedInformationAboutLoanModule",
  "containerID": "homeLoansDetailedInformationAboutLoanModule",
  "moduleName": "home-loans-detailed-information-about-loan-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "detailedInformationAboutLoanModule",
  "data": {
    "init": "detailedInformationAboutLoanModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        layerContent
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    layerContent
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.sales.helpers/module-utils-helper": "^2.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/currency-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-squeezebox-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @export
 * @class detailedInformationAboutLoanModule
 * @extends {Module}
 */
class detailedInformationAboutLoanModule extends Module {
  /**
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('.detailedInformationAboutLoanModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
    this.source = '';
    this.headlineMappings = [];
  }

  /**
   * @method helperPasser
   * @description Registers module-utils-helper functions
   * @return {void}
   */
  helperPasser() {
    Handlebars.registerHelper('currency', currencyRoundedInt);
    Handlebars.registerHelper('percentage', percentage);
    Handlebars.registerHelper('getCustomFormattedDate', getCustomFormattedDate);
  }

  /**
   * @method updateValues
   * @param {Object} response - Response object
   * @return {void}
   */
  updateValues(response) {
    const payload = response.data;
    const amountBorrowed = payload.amountBorrowed || 0;
    const programName = payload.mortgageProducts[0].programName || payload.mortgageProducts[0].productName;
    const product = payload.mortgageProducts[0];
    const {
      ahgeligibility,
      dpgeligibility
    } = product;
    const sectionKeys = Object.keys(product.detailedConditionResultMap);
    const detailedConditionResultMap = _.fromPairs(sectionKeys.map(key => {
      const value = _.fromPairs(product.detailedConditionResultMap[key].map(row => [row.name, row]));
      return [key, value];
    }));
    const context = {
      ...payload,
      mortgageProducts: [{
        ...product,
        detailedConditionResultMap
      }]
    };

    // cache selector
    const $success = this.$target.find('.wrapper');

    // map product name from server reponse and
    // then create new key/value in payload so hbs can pull it
    const serverProductName = context.mortgageProducts[0].productName || context.mortgageProducts[0].programName;
    let matchedValue = context.mortgageProducts[0].productName || context.mortgageProducts[0].programName;
    $.each(this.headlineMappings, (idx, val) => {
      // eslint-disable-line
      const arr = val.key.split(' ');
      let matchCnt = 0;
      $.each(arr, (idx, val) => {
        // eslint-disable-line
        if (serverProductName.toLowerCase().includes(val.toLowerCase())) {
          matchCnt++;
        }
      });
      if (matchCnt === arr.length) {
        matchedValue = val.value;
        return false;
      }
    });
    context.mortgageProducts[0].mappedProductName = matchedValue;

    // compile template
    const template = Handlebars.compile(this.source);

    // update values
    $success.html(template(context));
    /*
    note -
    there are multiple accordions on the CCC page which is causing this module's accordions
    to be initialized (on load) before we get the response back.
    Then, when we try to re-initialize it it doesn't work
    since there is a data-attr in the dom that says it's already there.
    This fix works since the accordion utility looks for classes .accordion-tab and .panel-header
    which aren't there initially but we will add them back right before we initialize it
    */
    $success.find('.accordion-tab-holder').removeClass('accordion-tab-holder').addClass('accordion-tab');
    $success.find('.panel-header-holder').removeClass('panel-header-holder').addClass('panel-header');
    spartaSqueezeboxUtility.init();
    if (ahgeligibility && dpgeligibility) {
      setTimeout(() => {
        $('.detailedInformationAboutLoanModule').find('.futureActions').show();
        $('.detailedInformationAboutLoanModule').find('.line2').show();
        $('.detailedInformationAboutLoanModule').find('.line1').hide();
        $('.detailedInformationAboutLoanModule').find('.custom-text').show();
      }, 500);
    } else if (!ahgeligibility && !dpgeligibility) {
      setTimeout(() => {
        $('.detailedInformationAboutLoanModule').find('.futureActions').hide();
        $('.detailedInformationAboutLoanModule').find('.custom-text').hide();
      }, 500);
    } else if (ahgeligibility && !dpgeligibility) {
      setTimeout(() => {
        $('.detailedInformationAboutLoanModule').find('.futureActions').show();
        $('.detailedInformationAboutLoanModule').find('.futureActions').show();
        $('.detailedInformationAboutLoanModule').find('.line2').hide();
        $('.detailedInformationAboutLoanModule').find('.line1').show();
        $('.detailedInformationAboutLoanModule').find('.custom-text').show();
      }, 500);
    } else if (!ahgeligibility && dpgeligibility) {
      setTimeout(() => {
        $('.detailedInformationAboutLoanModule').find('.futureActions').hide();
        $('.detailedInformationAboutLoanModule').find('.custom-text').hide();
      }, 500);
    }
    setTimeout(() => {
      $success.find('.closing-desc').html(programName);
      $success.find('.closing-amount').html(amountBorrowed);
    }, 700);
  }

  /**
   * @method callSpartaAccordion
   * @return {void}
   */
  callSpartaAccordion() {
    this.source = this.$target.find('.wrapper').html();
    this.getHeadlineMappingArr();
  }

  /**
   * @method getHeadlineMappingArr
   * @return {void}
   */
  getHeadlineMappingArr() {
    const $cache = this.$target.find('.wrapper');
    // get data values for headline text
    const dataMappings = $cache.find('.headline').attr('data-mapping');
    const arrMappings = dataMappings.split('^');
    $.each(arrMappings, (idx, val) => {
      const cache = val;
      const [key, value] = cache.replace(/(\s+)(\|\|)(\s+)/, '$2').trim().split('||');
      arrMappings[idx] = {
        key,
        value
      };
    });
    this.headlineMappings = arrMappings;
  }

  /**
   * @method fadeInModule
   * @return {void}
   */
  fadeInModule() {
    this.$target.fadeIn({
      duration: 200,
      easing: 'linear'
    });
  }

  /**
   * @method fadeOutModule
   * @return {void}
   */
  fadeOutModule() {
    this.$target.fadeOut({
      duration: 200,
      easing: 'linear'
    });
  }

  /**
   * @method init
   * @return {void}
   */
  init() {
    this.helperPasser();
    this.Events.sub('HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS', this.updateValues.bind(this));
    this.Events.sub('HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS', this.fadeInModule);
    this.Events.sub('HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE', this.fadeOutModule);
    const {
      loanType
    } = spaParams.pageParams;

    /* condition s to disaply */
    this.isMortgage = loanType === 'mortgage';
    this.isRefinance = loanType === 'refinance';
    this.callSpartaAccordion();
  }
}
registerModuleClass({
  moduleClass: detailedInformationAboutLoanModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { detailedInformationAboutLoanModule as default, moduleConfig };
